    <div class="modal-header">
        <h4 class="modal-title">Fakturaer</h4>
        <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
    </div>

    <div class="modal-body">
        <div class="table__viewport">
            <table class="table table-hover table-striped table-sm table-frame__body" >
                <thead class="fixed-top position-fixed position-sticky">
                    <tr>
                        <th class="text-nowrap">Fakturanr</th>
                        <th class="text-nowrap">Dato</th>
                        <th class="text-nowrap" colspan="2">Tekst</th>
                        <th class="text-nowrap">Beløb</th>
                    </tr>
                </thead>

                <tbody>
                <tr *ngFor="let item of faktura">
                    <td>{{ item.fakturaNr }}</td>
                    <td>{{ item.dato | date:'dd-MM-yyyy' }}</td>
                    <td colspan="2"> {{ item.tekst }}</td>
                    <td>{{ item.beloeb | currency:'DKK':'':'1.0-0':'da' }}</td>
                </tr>
                </tbody>

                <tfoot class="fixed-bottom position-fixed position-sticky">
                    <tr>
                        <th>Total</th>
                        <th></th>
                        <th colspan="2"></th>
                        <th>{{ amountTotal() | currency:'DKK':'':'1.0-0':'da'}}</th>
                    </tr>

                </tfoot>
            </table>
        </div>
    </div>
